
const changeQuantity = ($link, value) => {
	if ($link.length <= 0) {
		return;
	}

	let $input = $link.parent().find('input'),
		  count = parseInt($input.val()) + value;

	count = count < 1 ? 1 : count;
	$input.val(count);

	if (isNaN($input.val())){
		$input.val(1)
}

}
$(document).on('click','.js-countQuantity-arrow-down', function(event){
	event.preventDefault();
	changeQuantity($(this), -1);
});
$(document).on('click','.js-countQuantity-arrow-up', function(event) {
	event.preventDefault();
	changeQuantity($(this), 1);
});
$(document).on('change','.js-countQuantity-input', function(event){
	changeQuantity($(this), 0);
	if ($(this).val() < 1) {
		$(this).val(1);
	}
});